module.exports = __webpack_public_path__ + "img/brand8.f86d597d.png";